import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const PartnerWithUs = lazy(() => import("@/pages/PartnerWithUs"));

export const Route = createFileRoute("/_public/partner")({
  component: PartnerWithUs,
});
